import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import api from '@/lib/api';
import { applyBranding } from '@/lib/theme';

const SettingsContext = createContext(null);

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(null);

  const load = useCallback(async () => {
    try {
      const res = await api.get('/settings');
      setSettings(res.data);
      applyBranding(res.data);
    } catch (e) {
      // ignore — fall back to default theme
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const updateSettings = useCallback((next) => {
    setSettings(next);
    applyBranding(next);
  }, []);

  return (
    <SettingsContext.Provider value={{ settings, refresh: load, setSettings: updateSettings }}>
      {children}
    </SettingsContext.Provider>
  );
}

export function useSettings() {
  return useContext(SettingsContext) || { settings: null, refresh: () => {}, setSettings: () => {} };
}
